import React, { useEffect, useState } from 'react';
import { Button, Col, Modal, Row } from 'antd';
import './style.css'
import { getLabPatients, getQuickSearchResult } from '../../../api/api';
import { errorNotify } from '../../../services/toast.notification';
import { isEmpty, truncate } from 'lodash';
import Table, { ColumnsType } from 'antd/lib/table';
import Spinner from '../../../components/_common/Spinner';
import { NationalCodeValidation, PhoneNumberValidation } from '../../../components/_common/Validations/Index';
import SearchResult from './SearchResult';
import moment from 'moment';
import { useAppSelector } from '../../../redux/store/storehooks';

const SearchModal: React.FC<any> = (url: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [serachVal, setSearchVal] = useState('');
  const [searchMode, setSearchMode] = useState(1);
  const [activeButton, setActiveButton] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [searchResult, setSearchResult] = useState([]);
  const [validationErr, setValidationErr] = useState('');
  const [tableVisible, setTableVisible] = useState(true);
  const [selectedResult, setSelectedResult] = useState([]);
  const [lastSaja, setLastSaja] = useState('');
  const [lastPaja, setLastPaja] = useState('');
  const [lastCommon, setLastCommon] = useState('');
  const myStore = useAppSelector((state) => state)


  const columns: ColumnsType<any> = [
    { title: 'پذیرش', dataIndex: 'str_AdmitPatinet', key: 'str_AdmitPatinet' },
    { title: 'نام', dataIndex: 'Str_Name', key: 'Str_Name' },
    { title: 'کد ملی', dataIndex: 'Int_NationalCode', key: 'Int_NationalCode' },
    { title: 'سازمان', dataIndex: 'OrgName', key: 'OrgName' },
    { title: 'تاریخ پذیرش', dataIndex: 'Str_AdmitDate_Shamsi', key: 'Str_AdmitDate_Shamsi' },
    { title: 'مرحله', dataIndex: 'Str_WIP', key: 'Str_WIP' },
    { title: 'تاریخ تولد (سن)', dataIndex: 'Str_BirthDate_Age', key: 'Str_BirthDate_Age' },
  ];

  useEffect(() => {
    setValidationErr('');
    const handleEvent = (ev: KeyboardEvent) => {
      if (ev.code === 'F3') {
       _getPatientList();
      }

    };

    window.addEventListener('keydown', handleEvent);

  }, [])

  const buttonClick = (index: any) => {
    switch (index) {
      case 1:    //پذیرش
        serachVal.includes('-') ? setSearchMode(2) : setSearchMode(1)
        activeButton === 1 ? setActiveButton(0) : setActiveButton(1)
        break;

      case 2: //نام و نام خانوادگی
        setSearchMode(5);
        activeButton === 2 ? setActiveButton(0) : setActiveButton(2)
        break;

      case 3: //کدملی  
        setSearchMode(4);
        activeButton === 3 ? setActiveButton(0) : setActiveButton(3)
        break;

      case 4:   //مشاره موبایل
        setSearchMode(3);
        activeButton === 4 ? setActiveButton(0) : setActiveButton(4)
        break;


    }
  };

  const verifySearchInput = (value: any) => {
    if (!isNaN(+value)) {
      if (value.length === 11) {
        setActiveButton(4);

        let valid = PhoneNumberValidation(value);
        if (!valid) {
          setValidationErr('شماره تماس نادرست است!');
          return false;
        }
        setSearchMode(3);
      }
      else if (value.length === 10) {
        setActiveButton(3);

        let valid = NationalCodeValidation(value);
        if (!valid) {
          setValidationErr('کد ملی نادرست است!');
          return false;
        }
        setSearchMode(4);
      }
      else {
        setSearchMode(1);
        setActiveButton(1);
      }
    }
    else {
      if (value.includes('-')) {
        setSearchMode(2);
        setActiveButton(1);
      }
      else {
        setSearchMode(5);
        setActiveButton(2);
      }
    }
    return true;
  };

  const showModal = () => {
    setIsModalOpen(true);
    setValidationErr('');
    setSearchVal('');
    setActiveButton(0);
    setSearchMode(1);
    //_getPatientList();

  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  function handleChange(e: any) {
    let value;
    e.target.type === 'number' ? value = parseInt(e.target.value) : value = e.target.value
    //const { value } = event.target;  
    setSearchVal(value);
  };

  const handleKeyDown = (event: any) => {

    if (event.key === 'Enter') {
      setValidationErr('');
      let flag = verifySearchInput(serachVal);
      if (flag) {
        setIsLoading(true);
        getQuickSearchResult(url, searchMode, serachVal)
          .then((result: any) => {
            let jsonResult = JSON.parse(result.data.json);
            if (!isEmpty(jsonResult))
              setSearchResult(jsonResult.PatientInfo);
            //console.log(jsonResult.PatientInfo);
            setIsLoading(false);
            setTableVisible(true);
          })
          .catch((error) => {
            console.log(error);
            setIsLoading(false);
            errorNotify(error.response.data.errorMessage, undefined, 5000)
          })
      }
    }
  };

  const _getPatientList = () => {
    setIsLoading(true);

    var timeInMs = Date.now();
    var TodayDate= moment(timeInMs).locale('en').format('YYYY/MM/DD');

    getLabPatients(url.serviceUrl, TodayDate,0)
      .then((result: any) => {
        let lstSaja = result.filter((item:any)=>item.SajaAdmitPatient != null && item.SajaAdmitPatient != "");
        let lstPaja = result.filter((item:any)=>item.PajaAdmitPatient != null && item.PajaAdmitPatient != "");

        let lstSajaSorted = lstSaja.sort((a:any, b:any) => (b.SajaAdmitPatient > a.SajaAdmitPatient) ? 1 : -1);
        let lstPajaSorted = lstPaja.sort((a:any, b:any) => (b.PajaAdmitPatient > a.PajaAdmitPatient) ? 1 : -1);

        let lastSaja= lstSajaSorted[0];
        let lastPaja= lstPajaSorted[0];

        if(lastSaja != null)
          setLastSaja(lastSaja.DisplayID)

        if(lastPaja != null)
          setLastPaja(lastPaja.DisplayID)

        showModal()

        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
        errorNotify(error.response.data.errorMessage, undefined, 5000)
      })
  }

  return (
    <>
      {/* <Button type="primary" onClick={showModal}>
        Open Modal
      </Button> */}

      <Modal style={{ direction: 'rtl' }} title="جستجوی سریع  " open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={[]} width={800}>

        <Row style={{ marginBottom: '10px' }}>
          <Col md={12}>آخرین پذیرش بالینی: <span style={{ color: 'green' }}>{lastSaja}</span></Col>
          <Col md={12}>آخرین پذیرش پاتولوژی:  <span style={{ color: 'green' }}>{lastPaja}</span></Col>
        </Row>
        <div className="form-control" style={{ marginBottom: '18px', direction: 'rtl' }} >
          <input
            placeholder="جستجو"
            autoComplete="false"
            name="searchStr"
            id="searchStr"
            className="input-field"
            onChange={(e) => handleChange(e)}
            value={serachVal}
            onKeyDown={handleKeyDown}
          />
          <p style={{ color: 'red' }}>{validationErr}</p>
        </div>
        <Row>
          <Col md={6}>
            <Button key='1' name='admitID' style={{ width: '98%', backgroundColor: activeButton === 1 ? 'red' : '#40a9ff' }} type="primary" onClick={() => buttonClick(1)}>
              کد پذیرش
            </Button>
          </Col>
          <Col md={6}>
            <Button key='2' name='fullName' style={{ width: '98%', backgroundColor: activeButton === 2 ? 'red' : '#40a9ff' }} type="primary" onClick={() => buttonClick(2)}>
              نام و نام خانوادگی
            </Button>
          </Col>
          <Col md={6}>
            <Button key='3' name='nationalCode ' style={{ width: '98%', backgroundColor: activeButton === 3 ? 'red' : '#40a9ff' }} type="primary" onClick={() => buttonClick(3)}>
              کد ملی
            </Button>
          </Col>
          <Col md={6}>
            <Button key='4' name='mobileNumber ' style={{ width: '98%', backgroundColor: activeButton === 4 ? 'red' : '#40a9ff' }} type="primary" onClick={() => buttonClick(4)}>
              شماره موبایل
            </Button>
          </Col>
        </Row>

        {
          isLoading === false &&
          (
            <>
              {
                tableVisible === true && (
                  <Table onRow={(record, rowIndex) => {
                    return {
                      onClick: event => {
                        setSelectedResult(record);
                        setTableVisible(false);
                      },
                    }
                  }} scroll={{ x: 1500 }}
                    dataSource={searchResult} columns={columns}
                  />
                )
              }
              {
                tableVisible === false && (
                  <SearchResult data={selectedResult} url={url.url} serviceUrl={url.serviceUrl} />
                )
              }
            </>
          )
        }
        <Row style={{ justifyContent: 'center' }}>
          {
            isLoading === true &&
            (
              <div style={{ paddingTop: '15px' }}>
                <Spinner />
              </div>

            )
          }
        </Row>


      </Modal>
    </>
  );
};

export default SearchModal;